import { UAParser } from 'ua-parser-js';
import { Browser, BrowserType, OS } from './getSystemInfo.types';
const browserMap = {
    Firefox: Browser.Firefox,
    Chrome: Browser.Chrome,
    Safari: Browser.Safari,
    'Mobile Safari': Browser.Safari,
    Edge: Browser.Edge,
    Opera: Browser.Opera,
    IE: Browser.IE,
    'Samsung Internet': Browser.SamsungBrowser,
    Chromium: Browser.Chromium
};
const osMap = {
    Linux: OS.Linux,
    'Mac OS': OS.MacOS,
    Windows: OS.Windows,
    iOS: OS.IOS,
    Android: OS.Android,
    'Chromium OS': OS.ChromeOS
};
export const parser = new UAParser();
export const getSystemInfo = ()=>{
    const r = parser.getResult();
    let os = osMap[r.os.name ?? ''] ?? r.os.name ?? '';
    let osVersion = r.os.version ?? '';
    const browser = browserMap[r.browser.name ?? ''] ?? r.browser.name ?? '';
    const browserVersion = r.browser.major ?? '';
    const deviceType = r.device.type ?? BrowserType.Desktop;
    // Note: Safari on iPad may report the OS as macOS.
    if (r.device.model === 'iPad' && browser === Browser.Safari) {
        os = OS.IOS;
        // Note: The version of Safari on iOS is the same as the iOS version.
        osVersion = r.browser.version ?? '';
    }
    return {
        os,
        osVersion,
        browser,
        browserVersion,
        deviceType
    };
};

//# sourceMappingURL=getSystemInfo.js.map